import { useState } from 'react';

// eslint-disable-next-line import/prefer-default-export
export const useInput = (initialValue) => {
  const [value, setValue] = useState(initialValue);

  return {
    value,
    setValue,
    reset: () => setValue(''),
    bind: {
      value,
      onChange: (event) => {
        // @ts-ignore
        setValue(event.target.value);
      },
      required: true,
    },
  };
};
